export const RESET_PASSWORD = 'RESET_PASSWORD';

export const reset_pw_types = {
    RESET_PASSWORD_REQUEST: `${RESET_PASSWORD}_REQUEST`,
    RESET_PASSWORD_SUCCESS: `${RESET_PASSWORD}_SUCCESS`,
    RESET_PASSWORD_FAILURE: `${RESET_PASSWORD}_FAILURE`,
};


